<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
#app{
  background: #000;
}
html,body{
  width: 100% !important;
  background-color: #000;
}
.el-select-dropdown,
.el-select-dropdown__item.selected{
    background: #000;
    color: #fff;
}
.el-select-dropdown__item{
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/App.vue